import './HomeCookTogether.css'
import homeCookImage from '../../../assets/images/home_cook-together-image.webp'
import decorRight from '../../../assets/images/home_cook-together-decor-right.webp'
import decorLeft from '../../../assets/images/home_cook-together-decor-left.webp'
import { Link } from 'react-router-dom'

const HomeCookTogether = () => {
  return (
    <section className='home__cook-together-section'>
        <img src={decorRight} alt="декор" className="home__cook-together-decor-right" />
        <img src={decorLeft} alt="декор" className="home__cook-together-decor-left" />
        <h2 className="home__cook-together-title mont-m">Готовьте вместе с нами</h2>
        <p className="home__cook-together-text int-r-21">Молочная продукция – это безграничное поле для кулинарного творчества. Сливки, масло, сыры, йогурты – все это вдохновляет создавать домашние шедевры. Входите по идеям и рецептам на наш сайт и социальные сети.</p>
    <img src={homeCookImage} alt="Готуйте разом з нами" className="home_cook-together-image" />
    <Link to={"/ru/recipes"} className='home__cook-together-link int-r-21'>Перейти до рецептів</Link>
    </section>
  )
}

export default HomeCookTogether